import type { ReactNode } from 'react';
import BackendStatusProvider from './BackendStatusProvider';
import ProfileProvider from './ProfileProvider';
import ReleaseCheckProvider from './ReleaseCheckProvider';
import SendTransactionProvider from './SendTransactionProvider';

export default function Providers({ children }: { children: ReactNode }) {
  return (
    <BackendStatusProvider>
      <ReleaseCheckProvider>
        <ProfileProvider>
          <SendTransactionProvider>{children}</SendTransactionProvider>
        </ProfileProvider>
      </ReleaseCheckProvider>
    </BackendStatusProvider>
  );
}
